var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.07812L12.2555 6.15234L2.48984 9.42422L0.269531 10.1562L1.5625 10.5703V17.4062C1.09609 17.6773 0.78125 18.1719 0.78125 18.75C0.78125 19.1644 0.94587 19.5618 1.2389 19.8549C1.53192 20.1479 1.92935 20.3125 2.34375 20.3125C2.75815 20.3125 3.15558 20.1479 3.4486 19.8549C3.74163 19.5618 3.90625 19.1644 3.90625 18.75C3.90625 18.1719 3.59141 17.6773 3.125 17.4062V11.1094L4.6875 11.6211V15.625C4.6875 16.2656 5.07812 16.7969 5.54219 17.1641C6.00625 17.5289 6.58281 17.7867 7.275 18.018C8.66094 18.4789 10.4875 18.75 12.5 18.75C14.5125 18.75 16.3391 18.4797 17.725 18.0172C18.4172 17.7867 18.9938 17.5289 19.4578 17.1633C19.9219 16.7969 20.3125 16.2656 20.3125 15.625V11.6211L22.5102 10.8883L24.7305 10.1562L22.5094 9.42344L12.7437 6.15234L12.5 6.07812ZM12.5 7.71484L19.8242 10.1562L12.5 12.5977L5.17578 10.1562L12.5 7.71484ZM6.25 12.1586L12.2562 14.1602L12.5 14.2336L12.7445 14.1594L18.75 12.1578V15.625C18.75 15.6328 18.7531 15.7234 18.5055 15.918C18.2586 16.1133 17.8156 16.3594 17.2359 16.5531C16.0781 16.9383 14.3711 17.1875 12.5 17.1875C10.6289 17.1875 8.92188 16.9391 7.76328 16.5523C7.18516 16.3594 6.74141 16.1125 6.49453 15.918C6.24609 15.7227 6.25 15.6328 6.25 15.625V12.1578V12.1586Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearner);
export default __webpack_public_path__ + "static/media/learner.b7b870f618bdc02796b7ac608b6b43d8.svg";
export { ForwardRef as ReactComponent };